import type { GetAdminAccessResponse } from '@/types';
import api from './api';

export const adminAccessApi = {
  getAdminAccess: async (): Promise<GetAdminAccessResponse> => {
    return api.get('/api/v1/admin/access');
  },
};
